import { render, staticRenderFns } from "./PcTip.vue?vue&type=template&id=784c2434&scoped=true"
import script from "./PcTip.vue?vue&type=script&lang=js"
export * from "./PcTip.vue?vue&type=script&lang=js"
import style0 from "./PcTip.vue?vue&type=style&index=0&id=784c2434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c2434",
  null
  
)

export default component.exports